import { render, staticRenderFns } from "./WGWorldPlaceContainer.vue?vue&type=template&id=6844e68e&scoped=true&"
import script from "./WGWorldPlaceContainer.vue?vue&type=script&lang=js&"
export * from "./WGWorldPlaceContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6844e68e",
  null
  
)

export default component.exports